/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CourseModuleAssessmentTypesInner } from './courseModuleAssessmentTypesInner';
import { CourseModulePortfolioItemsInner } from './courseModulePortfolioItemsInner';
import { CourseModuleEpaItem } from './courseModuleEpaItem';
import { CourseModuleAssessmentItemsInner } from './courseModuleAssessmentItemsInner';
import { CourseModuleChecklistTypesInner } from './courseModuleChecklistTypesInner';
import { CourseModuleSettings } from './courseModuleSettings';
import { CourseModuleItem } from './courseModuleItem';
import { CourseModuleItemFeedback } from './courseModuleItemFeedback';
import { CourseModulePeerRolesInner } from './courseModulePeerRolesInner';
import { CourseModulePortfolioTypesInner } from './courseModulePortfolioTypesInner';


/**
 * 
 */
export interface CourseModule { 
    /**
     * 
     */
    id?: number;
    /**
     * 
     */
    ref?: string;
    /**
     * 
     */
    module: CourseModule.ModuleEnum;
    /**
     * 
     */
    moduleType?: string;
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    nl?: string;
    /**
     * 
     */
    du?: string;
    /**
     * 
     */
    fr?: string;
    /**
     * 
     */
    en?: string;
    /**
     * 
     */
    namePl?: string;
    /**
     * 
     */
    plNl?: string;
    /**
     * 
     */
    plDu?: string;
    /**
     * 
     */
    plFr?: string;
    /**
     * 
     */
    plEn?: string;
    /**
     * 
     */
    info?: string;
    /**
     * 
     */
    infoNl?: string;
    /**
     * 
     */
    infoDu?: string;
    /**
     * 
     */
    infoFr?: string;
    /**
     * 
     */
    infoEn?: string;
    /**
     * 
     */
    isPeerAssessment?: boolean;
    /**
     * 
     */
    createLink?: string;
    /**
     * 
     */
    cumulativeOverviewLink?: string;
    /**
     * 
     */
    assessmentTypes?: Array<CourseModuleAssessmentTypesInner>;
    /**
     * 
     */
    portfolioTypes?: Array<CourseModulePortfolioTypesInner>;
    /**
     * 
     */
    epaItems?: Array<CourseModuleEpaItem>;
    /**
     * 
     */
    peerRoles?: Array<CourseModulePeerRolesInner>;
    settings?: CourseModuleSettings;
    /**
     * 
     */
    checklistTypes?: Array<CourseModuleChecklistTypesInner>;
    /**
     * 
     */
    portfolioItems?: Array<CourseModulePortfolioItemsInner>;
    /**
     * 
     */
    assessmentItems?: Array<CourseModuleAssessmentItemsInner>;
    /**
     * 
     */
    documentItems?: Array<CourseModuleItem>;
    /**
     * 
     */
    itemCount?: number;
    /**
     * 
     */
    feedback?: Array<CourseModuleItemFeedback>;
}
export namespace CourseModule {
    export type ModuleEnum = 'feedback' | 'weekly-schedule' | 'attachments' | 'goals' | 'assessments' | 'checklist' | 'portfolio' | 'reflections' | 'epa-items';
    export const ModuleEnum = {
        Feedback: 'feedback' as ModuleEnum,
        WeeklySchedule: 'weekly-schedule' as ModuleEnum,
        Attachments: 'attachments' as ModuleEnum,
        Goals: 'goals' as ModuleEnum,
        Assessments: 'assessments' as ModuleEnum,
        Checklist: 'checklist' as ModuleEnum,
        Portfolio: 'portfolio' as ModuleEnum,
        Reflections: 'reflections' as ModuleEnum,
        EpaItems: 'epa-items' as ModuleEnum
    };
}


